import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import Select from "react-select";

const FormGroup = ({
  id,
  label,
  value,
  onChange,
  placeholder,
  error,
  type = "text",
  as = "input",
  options = [],
  disabled = false,
  additionalProps = {},
}) => {
  const Component = as; // Bisa berupa "input", "textarea", atau "select"

  return (
    <div className="row mb-3 align-items-center">
      <label
        htmlFor={id}
        className="col-sm-4 col-form-label d-flex justify-content-end"
        style={{ fontSize: "14px" }}
      >
        {label}:
      </label>
      <div className="col-sm-8">
        {as === "select" ? (
          <Select
            id={id}
            name={id}
            value={value}
            onChange={onChange}
            options={options} // React-select menggunakan `options` untuk daftar pilihan
            className={clsx(
              error && "is-invalid",
              "gotra-form-control rounded-1"
            )}
            placeholder={placeholder}
            isDisabled={disabled} // React-select menggunakan `isDisabled` untuk mengatur status disable
            {...additionalProps}
          />
        ) : (
          <Component
            id={id}
            name={id}
            type={type}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            className={clsx(
              "form-control gotra-form-control rounded-1",
              error && "is-invalid"
            )}
            disabled={disabled}
            {...additionalProps}
          />
        )}
        {error && <div className="invalid-feedback">{error}</div>}
      </div>
    </div>
  );
};

FormGroup.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  error: PropTypes.string,
  type: PropTypes.string,
  as: PropTypes.oneOf(["input", "textarea", "select"]),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
  disabled: PropTypes.bool,
  additionalProps: PropTypes.object,
};

export default FormGroup;
